// Utils
import { ToastsProvider } from '@/utils/hooks/context/toast/useToastsContext';
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import { DatepickerGlobalStoreProvider } from '@/utils/zustand/providers/datepicker-global-provider';

// Components
import Loader from '@/components/base/Loader';

export function GlobalWrapper({ children }: { children: React.ReactNode }) {
    const { isLoading } = useCurrentSession();

    if (isLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader className="h-6 w-6 text-icoBlue" />
            </div>
        );
    }

    return (
        <DatepickerGlobalStoreProvider>
            <ToastsProvider>
                <div className="flex h-full w-full">{children}</div>
            </ToastsProvider>
        </DatepickerGlobalStoreProvider>
    );
}
